import { Link } from 'react-router-dom';
import { C, wrap, BtnOrange } from '../styles';

export default function CTASection({
  heading = 'Get your project matched with an Ontario fabricator.',
  subtext = 'No CAD files required. Submit a sketch or photo and MetalMatch handles the brief.',
  buttonLabel = 'Submit Your Project →',
  to = '/',
}) {
  return (
    <section style={{ padding: '32px 0 80px' }}>
      <div style={wrap}>
        <div style={{
          borderTop: `1px solid rgba(232,76,61,0.35)`,
          borderBottom: `1px solid rgba(232,76,61,0.35)`,
          padding: '56px 24px', textAlign: 'center', position: 'relative', overflow: 'hidden',
        }}>
          <div style={{ position: 'absolute', inset: 0, background: `radial-gradient(ellipse at center, rgba(50,151,219,0.08) 0%, transparent 70%)`, pointerEvents: 'none' }} />
          <span style={{ fontSize: 11, fontWeight: 600, letterSpacing: '0.2em', textTransform: 'uppercase', color: C.orange, display: 'block', marginBottom: 12 }}>Ready to begin?</span>
          <h2 style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: 'clamp(26px, 4vw, 42px)', fontWeight: 700, textTransform: 'uppercase', color: C.txt, marginBottom: 14 }}>
            {heading}
          </h2>
          <p style={{ color: C.mut, fontSize: 15, maxWidth: 460, margin: '0 auto 26px', lineHeight: 1.7 }}>
            {subtext}
          </p>
          <Link to={to} style={{ textDecoration: 'none' }}>
            <BtnOrange>{buttonLabel}</BtnOrange>
          </Link>
        </div>
      </div>
    </section>
  );
}
